import React from 'react'
import { Flex, Text, Button, Link, Box } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled from 'styled-components'

interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
  images: any
}

const SalesSection: React.FC<SalesSectionProps> = (props) => {
  const { t } = useTranslation()
  const { headingText, bodyText, reverse, primaryButton, secondaryButton, images } = props

  const ButtonText = styled(Text)`
    display: none;
    ${({ theme }) => theme.mediaQueries.xs} {
      display: block;
    }
  `

  const ScrollBox = styled(Box)`
    padding: 20px;
    background: linear-gradient(145deg, #1c1c1c, #2a2a2a);
    border: 1px solid #FFD700;
    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.2);
    border-radius: 12px;
    margin: 20px 10px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
    }

    ${({ theme }) => theme.mediaQueries.md} {
      width: 220px;
    }
  `

  const ImageWrapper = styled.div`
    margin: 0 auto 15px;
    width: 80px;
    height: 80px;

    ${({ theme }) => theme.mediaQueries.md} {
      width: 100px;
      height: 100px;
    }
  `

  const StyledButton = styled(Button)`
    background-color: #333333;
    color: #FFD700;
    border: 2px solid #FFD700;
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.05);
      background-color: #444444;
      box-shadow: 0 0 15px rgba(255, 215, 0, 0.7);
    }
  `

  return (
    <ScrollBox>
      <Flex flexDirection="column" justifyContent="center" alignItems="center">
        <ImageWrapper>
          <img src="/images/pixel/S1.png" alt="ifo bunny" width="100%" height="100%" />
        </ImageWrapper>
        <Text color="#FFD700" bold fontSize="20px" mt="4px">
          {t('Trade')}
        </Text>
        <Text color="#B8B8B8" fontSize="16px" mt="4px">
          {t('Trade crypto instantly')}
        </Text>
        <Text color="#B8B8B8" fontSize="14px" mt="4px">
          {t('on multiple routers.')}
        </Text>
        <Link href="/swap">
          <StyledButton variant="tertiary" height="40px" mb="5px" mt="10px" width="100px">
            <ButtonText color="#FFD700" bold fontSize="14px">
              {t('TRADE NOW')}
            </ButtonText>
          </StyledButton>
        </Link>
      </Flex>
    </ScrollBox>
  )
}

export default SalesSection
